var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ag-app-bar'),(_vm.isAdminPortal)?_c('ag-admin-drawer'):_vm._e(),(!_vm.isAdminPortal)?_c('ag-my-drawer'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }